import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { isDevEnv } from "../common/utils";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfigProd = {
  apiKey: "AIzaSyCbmcVMkSgoonwnk4jZQ-pZgMAlF89p_X4",
  authDomain: "pulpo-club.firebaseapp.com",
  projectId: "pulpo-club",
  storageBucket: "pulpo-club-profile-images",
  messagingSenderId: "19856608668",
  appId: "1:19856608668:web:00773966b4772d4a12cc59",
  measurementId: "G-DQMVH4HC4K",
};

const firebaseConfigDev = {
  apiKey: "AIzaSyCd5SetM44wc_-uBhSRYyjjblncWOfuoF4",
  authDomain: "dev-pulpo.firebaseapp.com",
  projectId: "dev-pulpo",
  storageBucket: "dev-pulpo.appspot.com",
  messagingSenderId: "689655792688",
  appId: "1:689655792688:web:a83787b1e4d7d3e275d9f5",
};

firebase.initializeApp(isDevEnv() ? firebaseConfigDev : firebaseConfigProd);

if (typeof window !== "undefined" && !firebase.apps.length) {
  if ("measurementId" in firebaseConfigProd && !isDevEnv())
    firebase.analytics();
}

export const db = firebase.firestore();
export const auth = firebase.auth();
